import { join, skipEmpty } from '../../../../shared/location';
import { LocationSuggestionOption } from '../../location-search.types';

type Value = string | null;

export function sanitizePathString(value?: Value) {
  if (!value) {
    return value;
  }

  return value.trim().toLocaleLowerCase();
}

function makeString(value?: Value) {
  return value ? `${value}` : '';
}

export const getLocationDetailsAddress = (
  item: LocationSuggestionOption,
  multipleLocationsLabel?: string,
): string[] => {
  if (item.suggestionTypeCode === 'CURRENT') {
    return [];
  }

  if (item.typeCode === 'Other') {
    return multipleLocationsLabel ? [multipleLocationsLabel] : [];
  }

  const addressRows = skipEmpty([
    makeString(item.addressLine1),
    join([makeString(item.addressLine2), makeString(item.cityName)]),
    makeString(item.countryName),
  ]);

  return addressRows;
};

/**
 * Determines whether a suggestion has any station-level details worth showing
 * in the details panel. City suggestions (and similar non-station entries)
 * carry no address, hours of operation, or phone numbers, so the details panel
 * would render empty for them.
 */
export const hasLocationDetails = (item: LocationSuggestionOption): boolean => {
  const hasAddress = Boolean(
    item.addressLine1 || item.addressLine2 || item.postalCode,
  );
  const hasHours = (item.hoursOfOperation ?? []).length > 0;
  const hasPhones = (item.phones ?? []).length > 0;

  return hasAddress || hasHours || hasPhones;
};
